import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import Columns from "../../Columns";
import LinkComponent from "../../LinkComponent";
import List from "../../List";
import Button from "../../NewForms/Button";
import NewHeadline from "../../NewHeadline";
import ShapeContainer from "../../ShapeContainer";
import * as styles from "./style.module.scss";

const StyledContainer = styled.div`
    padding-top: 0;
    padding-bottom: 0;
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.left}
        ${theme.paddings.containerOuter.right}

        padding-bottom: 0;
    `}
`;

const StyledShapeContainer = styled(ShapeContainer)`
    margin-top: 0;
    margin-bottom: 0;
`;

const IconTextContainer = styled.div`
    display: flex;
    column-gap: 10px;
    align-items: flex-start;
    line-height: 2rem;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
`;

const ListWrapper = styled.div`
    margin-left: -18px;
`;

const ProductShapeList = ({ items }) => {
    const linkCss = css`
        margin-top: 12px;
    `;

    return (
        <StyledContainer>
            <StyledShapeContainer type="full-size">
                <Columns>
                    {items.map(
                        (
                            { name, items: subitems, onLoadMore, buttonText },
                            i
                        ) => (
                            <Columns.Column
                                key={i}
                                mobile="full"
                                tablet="full"
                                desktop="two-fifths"
                                className={
                                    i % 2
                                        ? "is-offset-one-fifth-desktop"
                                        : undefined
                                }
                            >
                                <NewHeadline>{name}</NewHeadline>
                                <Columns>
                                    {[0, 1].map((secondHalf, i) => (
                                        <Columns.Column
                                            key={i}
                                            mobile="full"
                                            tablet="half"
                                            desktop="half"
                                        >
                                            <ListWrapper>
                                                <List
                                                    className={styles.navList}
                                                    listStyleType="none"
                                                >
                                                    {subitems
                                                        .slice(
                                                            secondHalf
                                                                ? Math.ceil(
                                                                      subitems.length /
                                                                          2
                                                                  )
                                                                : 0,
                                                            secondHalf
                                                                ? undefined
                                                                : Math.ceil(
                                                                      subitems.length /
                                                                          2
                                                                  )
                                                        )
                                                        .map(
                                                            (
                                                                {
                                                                    text,
                                                                    href,
                                                                    icon,
                                                                },
                                                                i
                                                            ) => (
                                                                <List.Item
                                                                    key={i}
                                                                >
                                                                    {href ? (
                                                                        <LinkComponent
                                                                            css={
                                                                                linkCss
                                                                            }
                                                                            icon="arrow-right"
                                                                            link={{
                                                                                href,
                                                                                text,
                                                                            }}
                                                                            color="blue"
                                                                            bottomBorder
                                                                            fullWidth
                                                                        />
                                                                    ) : (
                                                                        <IconTextContainer>
                                                                            {
                                                                                icon
                                                                            }
                                                                            {
                                                                                text
                                                                            }
                                                                        </IconTextContainer>
                                                                    )}
                                                                </List.Item>
                                                            )
                                                        )}
                                                </List>
                                            </ListWrapper>
                                        </Columns.Column>
                                    ))}
                                </Columns>
                                {onLoadMore && buttonText && (
                                    <ButtonContainer>
                                        <Button
                                            fontSize="1rem"
                                            color="blueOutline"
                                            onClick={() =>
                                                onLoadMore(name.toLowerCase())
                                            }
                                        >
                                            {buttonText}
                                        </Button>
                                    </ButtonContainer>
                                )}
                            </Columns.Column>
                        )
                    )}
                </Columns>
            </StyledShapeContainer>
        </StyledContainer>
    );
};

export default ProductShapeList;
